import { render, staticRenderFns } from "./SelectMonetaryUnit.vue?vue&type=template&id=72213641&scoped=true&"
import script from "./SelectMonetaryUnit.vue?vue&type=script&lang=js&"
export * from "./SelectMonetaryUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72213641",
  null
  
)

export default component.exports